<template>
    <div class="count"><span class="sum">{{ count }}</span>Likes</div>
</template>

<script>

import { formatCount } from '@/library/GlobalHelper.js'

export default {
  name: 'FanCountFacebook',
  data () {
    return {
      count: '',
      timenow: new Date().getTime()
    }
  },
  mounted () {
    let social_fb = localStorage.getItem('social_fb')

    if (social_fb) {
      let fbCount = JSON.parse(social_fb)

      if ((this.timenow - fbCount.lastupdate) > ((48 * 60 * 60) * 1000)) {
        this.fetchSocialCount()
      } else {
        this.count = formatCount(fbCount.fb)
      }
    } else {
      this.fetchSocialCount()
    }
  },
  methods: {

    fetchSocialCount () {
      fetch(window._social_count).then(res => {
        return res.json()
      }).then(data => {
        let args = {
          'fb': data.fb,
          'lastupdate': this.timenow
        }
        localStorage.setItem('social_fb', JSON.stringify(args))
        this.count = formatCount(data.fb)
      })
    }

  }
}
</script>
